// The rotating announcement bar. Pauses while hovered or focused, and stays still for reduced motion.
import { reducedMotion } from '../lib/format.js';
export function mountAnnounce(root = document.querySelector('[data-announce]'), every = 4500) {
  if (!root) return;
  const msgs = [...root.querySelectorAll('.msg')]; let i = Math.max(0, msgs.findIndex(m => m.classList.contains('on'))), paused = false;
  const show = (d) => { msgs[i].classList.remove('on'); i = (i + d + msgs.length) % msgs.length; msgs[i].classList.add('on'); };
  root.addEventListener('click', e => { const b = e.target.closest('[data-ann]'); if (b) show(+b.dataset.ann); });
  ['mouseenter', 'focusin'].forEach(t => root.addEventListener(t, () => { paused = true; }));
  ['mouseleave', 'focusout'].forEach(t => root.addEventListener(t, () => { paused = false; }));
  if (!reducedMotion() && msgs.length > 1) setInterval(() => { if (!paused && !document.hidden) show(1); }, every);
}
